<template>
	<div class="main">
		Advertise
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #F9F6F3;
		padding: 20px;
		border: solid 0px #090;
	}
</style>
